import { render, staticRenderFns } from "./ElementModal.vue?vue&type=template&id=394da8e8&"
import script from "./ElementModal.vue?vue&type=script&lang=js&"
export * from "./ElementModal.vue?vue&type=script&lang=js&"
import style0 from "./ElementModal.vue?vue&type=style&index=0&id=394da8e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports